import React, { useRef, useEffect } from 'react'
import { jsGammaCorrection } from './utils'

const AugmentationEditorExposure = ({ selectedOption, previewImage }) => {
  const srcCanvasRef = useRef(null)
  const dstCanvasRef = useRef(null)

  useEffect(() => {
    if (!previewImage) return
    const getExposureValues = selectedOption.newValues || selectedOption.defaultValues
    const gamma = getExposureValues.gamma || 1.0
    const srcCanvas = srcCanvasRef.current
    const dstCanvas = dstCanvasRef.current
    const img = new window.Image()
    img.crossOrigin = 'anonymous'
    img.src = previewImage
    img.onload = () => {
      srcCanvas.width = img.width
      srcCanvas.height = img.height
      dstCanvas.width = img.width
      dstCanvas.height = img.height
      const ctx = srcCanvas.getContext('2d', { willReadFrequently: true })
      ctx.drawImage(img, 0, 0)
      jsGammaCorrection(srcCanvas, dstCanvas, gamma)
    }
  }, [selectedOption, previewImage])

  return (
    <>
      <canvas ref={srcCanvasRef} className='augmentation-editor-preview__canvas-spacer' />
      <canvas ref={dstCanvasRef} className='augmentation-editor-preview__canvas' />
    </>
  )
}

export default AugmentationEditorExposure